import React, { useEffect, useState } from 'react';

function getRandomPrice() {
    const min = 20;
    const max = 5000;
    const range = (max - min) / 10;
    const randomIndex = Math.floor(Math.random() * (range + 1));
    return min + (randomIndex * 10);
}
  const avatarStyle = {
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '1px solid #dfe7ec'
    };
const fixedBattles = [
    ["Sonu", "Gajender"],
    ["Govind", "Moti Singh"],
    ["Sanjay Kumar", "Surrender"],
    ["Ishwar Singh", "Sumit"],
    ["Sanjay Kumar", "Govind"],
    ["Ajay Kumar", "Amit"],
    ["Sonu Kumar", "Sumit"],
    ["Arun", "Raju"],
    ["Arpit", "Sai Kumar"],
    ["Parveen", "Bhupendra"],
    ["Arun", "Ajay Kumar"],
    ["Gorav", "Amit"],
    ["Sundar Lal", "Shobhit"],
    ["Pankaj", "Ranjeet"],
    ["Gourav", "Rashid"],
    ["Soyeb Khan", "Roshan Lal"],
    ["Khan Boy", "Babu Lal Mena"],
    ["Barat", "Ha"]
];

let battleIndex = 0;

function getNextBattle() {
    const pair = fixedBattles[battleIndex % fixedBattles.length];
    battleIndex += 1;
    const gameAmount = getRandomPrice();

    return {
        price: (gameAmount * 0.95 / 100).toFixed(2),
        Game_Ammount: gameAmount,
        ChallengerUser: { username: pair[0] },
        AcceptorUser: { username: pair[1] },
    };
}

const DummyRunningbattles = () => {
    const [fakeBattles, setFakeBattles] = useState([]);
    const avatarStyle = {
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        border: '1px solid #dfe7ec',
        backgroundColor: '#f2f5f7',
        color: '#7f8b94',
        fontSize: '20px'
    };

    useEffect(() => {
        const initialBattles = Array.from({ length: 10 }, () => getNextBattle());
        setFakeBattles(initialBattles);

        const intervalId = setInterval(() => {
            const newBattle = getNextBattle();
            setFakeBattles(prev => [...prev, newBattle]);
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <>
            <div className="fake-battles">
                {fakeBattles.map((battle, index) => (
                    <div
                        className="col-12 card border-0 my-2 px-0 mx-auto text-black overflow-hidden"
                        style={{
                            borderRadius: '14px',
                            background: '#ffffff',
                            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.06)',
                            border: '1px solid #e8ecef'
                        }}
                        key={index}
                    >
                        <div className="walletbody px-3 py-2">
                            <div className="row text-black align-items-stretch g-2">
                                <div className="col-4 d-flex align-items-center" style={{ minHeight: '96px' }}>
                                    <img
                                src={"/images/img.jpg"}
                                alt={    'Player 1'}
                                style={avatarStyle}
                                className="me-2"
                            />
                                    <p className="text-black font-bold mb-0" style={{ lineHeight: '1.3', fontSize: '14px', wordBreak: 'break-word' }}>
                                        {battle.ChallengerUser.username}
                                    </p>
                                </div>
                                <div
                                    className="col-4 d-flex flex-column align-items-center justify-content-center"
                                    style={{
                                        minHeight: '96px',
                                        borderRadius: '12px',
                                        background: 'linear-gradient(180deg, #f4fbf7 0%, #eef7ff 100%)',
                                        border: '1px solid #e3edf2'
                                    }}
                                >
                                    <span className="badge text-success px-2 py-1" style={{ fontSize: '12px', fontWeight: '800', backgroundColor: '#eaf8ef' }}>
                                        Bet: {battle.Game_Ammount}
                                    </span>
                                    <img src="/images/versus.png" className="my-1" style={{ width: '34px', height: '34px', objectFit: 'contain' }} alt="VS" />
                                    <span className="badge text-success px-2 py-1" style={{ fontSize: '12px', fontWeight: '800', backgroundColor: '#eaf8ef' }}>
                                        Won: {battle.Game_Ammount + battle.Game_Ammount}
                                    </span>
                                </div>
                                <div className="col-4 d-flex align-items-center justify-content-end" style={{ minHeight: '96px' }}>
                                    <p className="text-black font-bold text-end mb-0 mr-2" style={{ lineHeight: '1.3', fontSize: '14px', wordBreak: 'break-word' }}>
                                        {battle.AcceptorUser.username}
                                    </p>
                                    <img
                                src={"/images/img.jpg"}
                                alt={'Player 1'}
                                style={avatarStyle}
                                className="me-2"
                            />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default DummyRunningbattles;